<template>
  <div class="card" :class="{'disabled': isDisabled }">
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none">
      <symbol id="checkmark" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-miterlimit="10" fill="none"  d="M22.9 3.7l-15.2 16.6-6.6-7.1">
        </path>
      </symbol>
    </svg>
    <div class="card-body">
      <div class="check-group">
        <input type="checkbox" id="showLockers" name="showLockers" class="reverse" v-on:change="highlightLockers" v-bind:checked="$store.state.isLockerHighlighted" />
        <label for="showLockers" id="checkbox">
            <svg viewBox="0 0 100 100">
                <path class="box" d="M82,89H18c-3.87,0-7-3.13-7-7V18c0-3.87,3.13-7,7-7h64c3.87,0,7,3.13,7,7v64C89,85.87,85.87,89,82,89z"/>
                <polyline class="check" points="25.5,53.5 39.5,67.5 72.5,34.5 "/>
            </svg>
            <div>{{$t("parcelshopPicker.parcelshopLockerSelectionCard.showLocker")}}<p>{{$t("parcelshopPicker.parcelshopLockerSelectionCard.explanation")}}</p></div>
        </label>
      </div>
      <!-- <div class="parcelshop-picker-icon-locker check-group">
          <input type="checkbox" id="showLockers" class="checkbox" v-bind:disabled="isDisabled" v-on:change="highlightLockers" v-bind:checked="$store.state.isLockerHighlighted">
          <label for="showLockers" class="label">
              <span class="custom-checkbox"></span>
              <div>{{$t("parcelshopPicker.parcelshopLockerSelectionCard.showLocker")}}<p>{{$t("parcelshopPicker.parcelshopLockerSelectionCard.explanation")}}</p></div>
          </label>
      </div> -->
    </div>
  </div>
</template>

<script>
import { isLocker } from "../../utils/amazonLocker";

export default {
  computed: {
    isDisabled: function () {
      return !this.$store.state.parcelshopList.some(e => isLocker(e));
    }
  }, 
  methods: {
    highlightLockers: function() {
      this.$store.commit('setIsLockerHighlighted', !this.$store.state.isLockerHighlighted);
    }
  }
}
</script>

<style scoped>
.card {
  padding-top: 5px;
  height: 70px;
}

.new .container .internal-page .check-group {
  width: unset !important;
  margin-top: 0!important;
  margin-bottom: 0!important;
    padding-top: 2px;
}
.new .internal-page .check-group input[type="checkbox"] + label {
    border: none;
    text-align: left !important;
    padding: 3% 20px 3% 50px;
}
.new .internal-page .check-group input[type="checkbox"] + label span {
    top: 45%;
    left: 0;
}
.parcelshop-picker-icon-locker {
    /*background-image: url('data:image/png;base64,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');
    background-size: 50px 60px;
    background-position: left middle;
    background-repeat: no-repeat;
    padding-left: 60px;*/
    min-width: 75px;
    height: 60px;
    padding-top: 5px;
    margin: 5px 0 5px 15px !important;
}

    .parcelshop-picker-icon-locker .label div p{
          font-style:italic;
        clear:both;
        padding:0;
        margin:0;
        padding-top:2px;
        font-size:0.9em;}

.new .disabled input:focus ~ label, .new .disabled input:valid ~ label {
    position: relative !important;
}
@media (max-width: 767.98px) { 
  .card {
    padding-top: 0;
  }
  .parcelshop-picker-icon-locker {
    padding-left:10px;
  }
  .new .internal-page .check-group input[type="checkbox"] + label {
    padding: 10% 20px 10% 40px;
    max-width: 60vw;
  }
  .parcelshop-picker-icon-locker .label div p{
  display:none;}
}

input[type=checkbox] {  
    display: none;  
    pointer-events: none;  
}  
  
input[type=checkbox] + label {  
    border: none !important;  
    padding: 3% 10px 3% 30px !important;  
    cursor: pointer;  
    font-size: .8em;  
    display: grid;  
    grid-template-columns: auto 3fr;  
    text-align: left !important;  
}  
  
input[type=checkbox] + label svg {  
    width: 2em;  
    stroke: #96154a;  
    stroke-width: 5;  
    fill: white;  
    float: left !important;  
}  
  
input[type=checkbox] + label svg .box {  
    stroke-dasharray: 320;  
    stroke-dashoffset: 0;  
    fill: white !important;  
}  
  
input[type=checkbox] + label svg .check {  
    stroke-dasharray: 70;  
    stroke-dashoffset: 70;  
    fill: none;  
}  
  
input[type=checkbox] + label div {  
    float: left;  
    padding: 6px;  
    width: 90%;  
    padding-top: 0px;  
}  
  
input[type=checkbox] + label span {  
    padding-top: .3em;  
    margin-left: .3em;  
}  
  
input[type=checkbox]:checked + label .box {  
    stroke-dashoffset: 0;  
    transition: stroke-dashoffset .3s linear;  
}  
  
input[type=checkbox]:checked + label .check {  
    stroke-dashoffset: 0;  
    transition: stroke-dashoffset .3s linear;  
}  
  
.reverse .box {  
    stroke-dashoffset: 0;  
    transition: stroke-dashoffset .3s linear;  
}  
  
.reverse .check {  
    stroke-dashoffset: 70;  
    transition: stroke-dashoffset .3s linear;  
}  
</style>
